import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddSiteModal from "./modals/AddSiteModal";
import { EditIcon } from "../assets/Icons";
import SiteCSV from "../components/modals/SiteCSV";

const SubSiteList = ({ siteId = "" }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [names, setNames] = useState([]);
  const [showSiteModal, setShowSiteModal] = useState(false);
  const [updateSite, setUpdateSite] = useState();
  const [siteListCSVModal, setSiteListCSVModal] = useState(false);

  const fetchNames = async () => {
    try {
      const { data } = await axios.get(`${configData.config.API_URL}/api/site/subsites/list/${siteId}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setNames(data?.data);
    } catch (error) {
      console.error("Error fetching names:", error);
    }
  };

  useEffect(() => {
    if (siteId) fetchNames();
  }, [siteId]);

  return (
    <>
      <div className="d-flex justify-content-end mb-3 gap-3">
        {userData?.user?.permissions?.includes("MACHINE.ADD") && (
          <>
            <button
              className="plain-btn"
              title="Back"
              onClick={() => {
                setUpdateSite(null);
                setShowSiteModal(true);
              }}
            >
              Add Site List
            </button>
            <button
              className="plain-btn "
              title="Back"
              onClick={() => {
                setSiteListCSVModal(true);
              }}
            >
              Upload CSV
            </button>
          </>
        )}
      </div>

      <div className="table-responsive mt-3">
        {names.length > 0 ? (
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th style={{ width: "10%" }} className="text-center">
                  S.No
                </th>
                <th className="text-center">Site Name</th>
                <th className="text-center">OBR BU</th>
                <th className="text-center">OBR ORG</th>
                <th className="text-center">Country</th>
                <th className="text-center">Region</th>
                {userData?.user?.permissions?.includes("MACHINE.ADD") && <th className="text-center">Actions</th>}
              </tr>
            </thead>
            <tbody>
              {names.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item?.name || "N/A"}</td>
                  <td className="text-center">{item?.obrBu || "N/A"}</td>
                  <td className="text-center">{item?.obrOrg || "N/A"}</td>
                  <td className="text-center">{item?.country || "N/A"}</td>
                  <td className="text-center">{item?.region || "N/A"}</td>
                  {userData?.user?.permissions?.includes("MACHINE.ADD") && (
                    <td>
                      <div
                        className="action-btns "
                        onClick={() => {
                          setUpdateSite({
                            name: item?.name,
                            uuid: item?.uuid,
                            obrBu: item?.obrBu,
                            obrOrg: item.obrOrg,
                            country: item?.country,
                            region: item?.region,
                          });
                          setShowSiteModal(true);
                        }}
                      >
                        <span>
                          <EditIcon />
                        </span>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No subsites found.</p>
        )}
      </div>
      <div>
        <AddSiteModal
          show={showSiteModal}
          setShow={setShowSiteModal}
          siteId={siteId}
          onSave={fetchNames}
          data={updateSite}
        />
      </div>

      <SiteCSV CSVModal={siteListCSVModal} setCSVModal={setSiteListCSVModal} onSubmit={fetchNames} />
    </>
  );
};

export default SubSiteList;
